import React from 'react';
import { useTheme, Box, Typography, Grid } from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const PerformanceGauge = ({ 
    size=50, 
    fontSize=12, 
    title, 
    indicator, 
    pathColor, 
    legend, 
}) => {
    const theme = useTheme();  
    const primaryDark = theme.palette.primary.dark;
    const primaryAlt = theme.palette.primary.lightest;


    return (
        <Grid container spacing={2}>
            <Grid>
                <Typography fontSize={`${fontSize}px`} textAlign="center">{title}</Typography>
                <Box width={size} height={size} mx="auto">
                    <CircularProgressbar
                        value={indicator}
                        text={`${indicator}%`}
                        styles={buildStyles({
                            pathColor: pathColor || primaryAlt, 
                            textColor: primaryDark,
                            trailColor: '#555',
                        })}
                    />
                </Box>
                {legend && (
                    <Box mt={1}>
                        {legend.map((item, index) => (
                            <Box key={index} display="flex" alignItems="center" mt={1}>
                                <Box width="15px" height="15px" bgcolor={item.color} mr={1} />
                                <Typography variant="body2">{`${item.label}: ${item.value}%`}</Typography>
                            </Box>
                        ))}
                    </Box>
                )}
            </Grid>
        </Grid>
    );
};

export default PerformanceGauge;